module.exports = __webpack_public_path__ + "media/files/sample_eligibility_file-56f5ae6e6574c58060d3e2fcc804f733.xls";